<template>
  <div>
    <div class="w-100 h-100">
      <Nav :rolname="rolname" />
    </div>
    <div class="content h-100" style="background: rgb(255, 255, 255)">
      <HomeVue
        v-if="page == 'home'"
        :pageView="page"
        @changePage="changePage"
        @mtdBackCampus="mtdBackCampus"
      />
      <OrdenesVue
        v-if="page == 'orders'"
        @mtdBackCampus="mtdBackCampus"
        @changePage="changePage"
      />
      <MaintenanceVue
        v-if="page == 'maintenance'"
        @mtdBackCampus="mtdBackCampus"
        @changePage="changePage"
      />
    </div>
    <div class="footer">
      <FooterVue @mtdChangePage="mtdChangePage" :pageView="page" />
    </div>
  </div>
</template>

<script>
import Nav from "@/components/Laboratorio/Nav.vue";
import FooterVue from "@/components/Laboratorio/Footer.vue";
import HomeVue from "@/components/Laboratorio/Home.vue";
import OrdenesVue from "@/components/Laboratorio/pages/Ordenes.vue";
import MaintenanceVue from "@/components/Laboratorio/pages/Maintenance.vue";

export default {
  name: "v-lab-view",
  components: {
    Nav,
    FooterVue,
    HomeVue,
    OrdenesVue,
    MaintenanceVue,
  },
  data() {
    return {
      page: "home",
      rol_name: null,
    };
  },
  props: {
    rolname: String,
  },
  methods: {
    changePage: function (page) {
      this.page = page;
    },
    returnHome: function () {
      this.page = "home";
    },
    mtdBackCampus: function () {
      this.$emit("mtdBackCampus");
    },
    mtdChangePage: function (page) {
      this.page = page;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>